import React, { useState } from 'react';

import DollarOutput from '../../utils/DollarOutput';

export type StripeRefundRowProps = {
  id: string;
  amount: number;
  status: string;
  createdAt: string;
};
export type StripeChargeRowProps = {
  id: string;
  amount: number;
  refundAmount: number;
  status: string;
  createdAt: string;
  stripeLink: string;
  refunds: StripeRefundRowProps[];
};

const StripeChargesRow = (props: StripeChargeRowProps) => {
  const [expanded, setExpanded] = useState(false);
  const hasRefunds = props.refundAmount > 0;

  const toggleRefunds = () => {
    setExpanded(!expanded);
  };
  const renderToggleRefundsCell = () => (
    <button
      className={'btn-link btn-xs stripe-charges__toggle-button'}
      onClick={toggleRefunds}
    >
      <i
        className={`fas fa-lg ${
          expanded ? 'fa-minus-square' : 'fa-plus-square'
        }`}
      />
    </button>
  );

  const renderChargeAmountsCell = () => (
    <>
      <DollarOutput value={props.amount} />
      {hasRefunds && (
        <span className={'stripe-charges__details--refund'}>
          (<DollarOutput value={-props.refundAmount} />)
        </span>
      )}
    </>
  );

  const renderStripeRefundRow = (refund: StripeRefundRowProps) => (
    <tr
      key={refund.id}
      className={'stripe-charges__row stripe-charges__details--refund'}
    >
      <td />
      <td>{refund.id}</td>
      <td>
        <DollarOutput value={-refund.amount} />
      </td>
      <td>{refund.status}</td>
      <td>{refund.createdAt}</td>
      <td />
      <td />
    </tr>
  );

  return (
    <>
      <tr className={'stripe-charges__row stripe-charges__details--charge'}>
        <td className={'stripe-charges__cell--toggle'}>
          {hasRefunds && renderToggleRefundsCell()}
        </td>
        <td>{props.id}</td>
        <td>{renderChargeAmountsCell()}</td>
        <td>{props.status}</td>
        <td>{props.createdAt}</td>
        <td>
          <a target={'_blank'} rel={'noreferrer'} href={props.stripeLink}>
            View Charge
          </a>
        </td>
      </tr>
      {expanded && props.refunds.map(renderStripeRefundRow)}
    </>
  );
};

export default StripeChargesRow;
